<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
        <v-avatar
          @click="toMyCard"
          size="40px"
          v-bind="attrs"
          color="primary"
          class="v-avatar-light-bg primary--text mx-4 "
          v-on="on"
        >
          <img :src="`https://myops.accenture.cn/myops/proxy/images/blog/${eid}.jpg`">
        </v-avatar>
    </template>
  </v-menu>
</template>

<script>
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
} from '@mdi/js'
import { store } from '@/myops/core'

export default {
  methods:{
    toMyCard(){
      let routerData = this.$router.resolve({ path:'/myBooks' })
      window.open(routerData.href,'_blank')
    }
  },
  setup() {
    return {
      eid:store.state.user.user.eid,
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },
    }
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
.v-application.skin-variant--bordered .theme--light.v-menu__content {
  border: 0px !important;
}
</style>
